import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { DomainClaimDetailsSearchParams, DomainClaimDetails } from '@css-xp/support-service-types';

const client = createAxiosClient({ baseURL: '/api/1/domains' }, ServiceProxyMap.SUPPORT);

export async function searchDomainClaimDetails(
  searchOptions: DomainClaimDetailsSearchParams
): Promise<DomainClaimDetails> {
  const result = await client.get('/', { params: searchOptions });

  return result.data;
}
